declare global {
  interface Window {
    queryValidInAppPurchases: () => void
  }
}

export function useQueryInAppPurchases() {
  const queryInAppPurchases = () => {
    if(window.queryValidInAppPurchases) {
      window.queryValidInAppPurchases()
    }
  };

  return [queryInAppPurchases];
}